(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["inspiration-gallery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.inspiration-gallery__item');
    if (trigger) {
      var gallery = trigger.closest('.inspiration-gallery');
      var dialog = gallery && gallery.querySelector('.inspiration-gallery__lightbox');
      if (!dialog) return;
      var items = Array.prototype.slice.call(gallery.querySelectorAll('.inspiration-gallery__item'));
      openLightbox(dialog, items, items.indexOf(trigger));
      return;
    }

    var closeBtn = event.target.closest('[data-lightbox-close]');
    if (closeBtn) {
      var closeDialog = closeBtn.closest('.inspiration-gallery__lightbox');
      if (closeDialog) closeDialog.close();
      return;
    }

    var nextBtn = event.target.closest('[data-lightbox-next]');
    if (nextBtn) {
      step(nextBtn.closest('.inspiration-gallery__lightbox'), 1);
      return;
    }

    var prevBtn = event.target.closest('[data-lightbox-prev]');
    if (prevBtn) {
      step(prevBtn.closest('.inspiration-gallery__lightbox'), -1);
      return;
    }

    var openDialog = event.target.closest('.inspiration-gallery__lightbox');
    if (event.target.classList && event.target.classList.contains('inspiration-gallery__lightbox')) {
      event.target.close();
    }
  });

  document.addEventListener('keydown', function (event) {
    var dialog = document.querySelector('.inspiration-gallery__lightbox[open]');
    if (!dialog) return;
    if (event.key === 'ArrowRight') step(dialog, 1);
    if (event.key === 'ArrowLeft') step(dialog, -1);
  });

  var touchStartX = null;

  document.addEventListener('touchstart', function (event) {
    var dialog = event.target.closest('.inspiration-gallery__lightbox[open]');
    if (!dialog) return;
    touchStartX = event.changedTouches[0].clientX;
  });

  document.addEventListener('touchend', function (event) {
    var dialog = event.target.closest('.inspiration-gallery__lightbox[open]');
    if (!dialog || touchStartX === null) return;
    var deltaX = event.changedTouches[0].clientX - touchStartX;
    touchStartX = null;
    if (Math.abs(deltaX) < 40) return;
    step(dialog, deltaX < 0 ? 1 : -1);
  });

  function openLightbox(dialog, items, index) {
    dialog.inspirationGalleryItems = items;
    dialog.inspirationGalleryIndex = index;
    renderLightbox(dialog);
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    }
  }

  function step(dialog, delta) {
    if (!dialog || !dialog.inspirationGalleryItems) return;
    var length = dialog.inspirationGalleryItems.length;
    dialog.inspirationGalleryIndex = (dialog.inspirationGalleryIndex + delta + length) % length;
    renderLightbox(dialog);
  }

  function renderLightbox(dialog) {
    var item = dialog.inspirationGalleryItems[dialog.inspirationGalleryIndex];
    if (!item) return;
    var image = dialog.querySelector('[data-lightbox-image]');
    var caption = dialog.querySelector('[data-lightbox-caption]');
    var title = item.getAttribute('data-title');
    if (image) {
      image.src = item.getAttribute('data-full-src');
      image.alt = title;
    }
    if (caption) caption.textContent = title;
  }
  } catch(e) { console.error(e); }
})();

})();
